"use client";
import * as React from "react";
const SvgPaymentSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 .5H0v13h16zm-1.6 11.38H1.6V7h12.8zm0-8.13H1.6V2.13h12.8z" }));
export {
  SvgPaymentSharp as default
};
